module.exports = __webpack_public_path__ + "img/dialog_info.974d9cec.svg";